import React, { useEffect, useState } from 'react';
import { Row, Col, Card, Space, DatePicker, Drawer, Form, Input, Select, Radio, message, Modal, Pagination, Tabs } from 'antd';
import { Table, Button } from 'antd';
import BreadcrumbCustom from '../../components/widget/BreadcrumbCustom';
import { DownOutlined, ExclamationCircleOutlined, MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import moment from 'moment';
import CardList from '../card/CardList';
import ScheduleList from '../schedule/ScheduleList';
import CourseDefinitionList from '../card/CourseDefinitionList';
import ClassroomList from './ClassroomList';
import TeachClassList from './TeachClassList';
import TeachClassDataList from '../data/TeacherDataList';
import { IStore, listStores } from '../../service/api/store';

const { TabPane } = Tabs;
const { Option } = Select;


const ScheduleView = (props: any) => {

  const [currentTabKey, setCurrentTabKey] = useState<number>(1);
  const [classroomVisible, setClassroomVisible] = useState(false);
  const [teachClassVisible, setTeachClassVisible] = useState(false);
  const [stores, setStores] = useState<IStore[]>();
  const [filterStoreIds, setFilterStoreIds] = useState<number[]>();
  const [searchTeachClassKeyword, setSearchTeachClassKeyword] = useState<string>();

  function getUrlParam(name: string, str: string) {
    const paramUrl = str.split('?');
    if (paramUrl.length == 1) {
      return null;
    }
    const params = paramUrl[1].split('&');
    for (var i = 0; i < params.length; i++) {
      const value = params[i].split('=');
      if (value[0] == name) {
        return value[1];
      }
    }
    return null;
  }

  const tabExtraContent = () => {
    switch (currentTabKey) {
      case 1:
        return <Select placeholder="全部校区"
                style={{ minWidth: 180, marginRight: '20px' }} mode="multiple"
                onChange={(value: any) => {
                  setFilterStoreIds(value);
                }}
              // allowClear
              >
                {storeOptions}
              </Select>
      case 2:
        return <div>
          <Select placeholder="全部校区"
            style={{ minWidth: 180, marginRight: '10px' }} mode="multiple"
            onChange={(value: any) => {
              setFilterStoreIds(value);
            }}
          // allowClear
          >
            {storeOptions}
          </Select>
          <Input type='text' placeholder="请输入名称/备注" style={{ width: 200, marginRight: '10px' }}
              onChange={(e)=>{
                setSearchTeachClassKeyword(e.target.value)}}
              allowClear>
          </Input>
          <Button type="primary" style={{marginRight: '20px' }} onClick={() => {
            setTeachClassVisible(true);
          }} icon={<PlusOutlined />}>
            新增班级
        </Button>
        </div>
      case 3:
        return <Button type="primary" style={{marginRight: '20px' }} onClick={() => {
          setClassroomVisible(true);
        }} icon={<PlusOutlined />}>
          新增教室
        </Button>
      default:
        return <></>
    }
  }

  // 下拉框值
  const storeOptions = stores?.map((store) =>
    <Option key={store.id} value={store.id}>{store.name}</Option>);

  function onTabChange(key: any) {
    console.log(key);
    setCurrentTabKey(Number(key));
  }

  useEffect(() => {
    loadData();
    const index = getUrlParam('index', window.location.href);
    if(index){
      setCurrentTabKey(Number(index));
    }
  }, []);

  const loadData = () => {
    listStores().then((info: any) => {
      setStores(info?.data);
    });
  }

  return (
    <div className="gutter-example">
      <BreadcrumbCustom breads={['排课管理']} />
      <Row gutter={16}>
        <Col className="gutter-row" md={24}>
          <div className="gutter-box">
            <Tabs defaultActiveKey={getUrlParam('index', window.location.href)!} onChange={onTabChange} style={{ marginBottom: 32 }}
              tabBarExtraContent={tabExtraContent()}>
              <TabPane tab="排课视图" key="1">
                <ScheduleList 
                filterStoreIds={filterStoreIds}
                />
              </TabPane>
              <TabPane tab="班级管理" key="2">
                <TeachClassList
                  visible={teachClassVisible}
                  setVisible={setTeachClassVisible}
                  filterStoreIds={filterStoreIds}
                  searchKeyword={searchTeachClassKeyword}
                />
              </TabPane>
              <TabPane tab="教室管理" key="3">
                <ClassroomList
                  visible={classroomVisible}
                  setVisible={setClassroomVisible}
                />
              </TabPane>
            </Tabs>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ScheduleView;
